import React, {useContext} from 'react';
import AppInfo from "./AppInfo";
import WebGLInfo from "./WebGLInfo";
import {AppManagerContext} from "../../Common/Contexts";
import Box from "../../Common/Box";

const AppStats = () => {

    const {renderers} = useContext(AppManagerContext);

    return <Box column overflow={"auto"}>
        <AppInfo/>
        <WebGLInfo renderers={renderers}/>
    </Box>
};

export default AppStats;
